import { type ParsedUrlQuery } from 'querystring'

import { type TherapistPriceType, type TherapistType } from '../../../types/TherapistStateType'
import { FILTER_SPECIALIZATION_SLUG } from '../../filters/filters.constants'
import { SORT_DESC_SLUG, SORT_SLUG } from '../../filters/sort.constants'

const getPriceByServiceId = (therapist: TherapistType, service: number) => {
  const priceObj = therapist.prices?.find((price: TherapistPriceType) => price.serviceId === service)
  return priceObj ? priceObj.price : 0
}
const sortByValue = (data: TherapistType[], value: string, desc: boolean, service) => {
  if (data.length === 0) {
    return []
  }

  if (value === 'prices') {
    return [...data].sort((a: TherapistType, b: TherapistType) => {
      const priceA = getPriceByServiceId(a, service)
      const priceB = getPriceByServiceId(b, service)

      if (priceA < priceB) {
        return desc ? 1 : -1 // Sort in descending order if desc is true
      } else if (priceA > priceB) {
        return desc ? -1 : 1 // Sort in ascending order if desc is true
      }

      return 0
    })
  }

  return [...data].sort((a, b) => {
    if (desc) {
      return b[value] - a[value]
    }
    return a[value] - b[value]
  })
}

export const sortObjectsByMajorSpecialization = (data, value) => {
  const hasValue = (obj) => obj.majorSpecializations.includes(value)

  return [...data].sort((a, b) => hasValue(b) - hasValue(a))
}

export const sortTherapists = (
  therapists: TherapistType[],
  query: ParsedUrlQuery,
  service: number,
): TherapistType[] => {
  const sorting = query[SORT_SLUG] as string
  const desc = query[SORT_DESC_SLUG] === 'true'
  const specialization = parseInt(query[FILTER_SPECIALIZATION_SLUG] as string, 10)

  if ((!sorting || sorting === 'retentionSort') && !specialization) return therapists

  if (specialization && (!sorting || sorting === 'retentionSort')) {
    return sortObjectsByMajorSpecialization(therapists, specialization)
  }

  // filter is price but therapist contains array of prices
  return sortByValue(therapists, sorting.startsWith('price') ? 'prices' : sorting, desc, service)
}
